function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pool_svg__clip0_1_67)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.248 10.413v-1.05h4.204v1.05a1.05 1.05 0 102.101 0v-7.26c0-.58.472-1.051 1.051-1.051a1.05 1.05 0 100-2.102 3.156 3.156 0 00-3.152 3.153v1.05H3.248v-1.05c0-.58.472-1.051 1.051-1.051a1.05 1.05 0 100-2.102 3.156 3.156 0 00-3.153 3.153v7.26a1.05 1.05 0 102.102 0zm4.204-4.681v2.102H3.248V5.732h4.204zm-.47 5.732l-.075.155c-.61 1.272-2.421 1.272-3.031 0l-.075-.155-.075.155c-.61 1.272-2.42 1.272-3.03 0l-.075-.155s-.293.38-.621.877c.312 2.735 2.653 3.696 5.465 3.658 2.757-.037 5.001-.98 5.311-3.649-.33-.506-.615-.886-.615-.886l-.074.155c-.61 1.272-2.421 1.272-3.031 0l-.075-.155z",
  fill: "currentColor"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pool_svg__clip0_1_67"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v16H0z"
})));
function SvgPool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgPool;